import React, { Component } from 'react'
import { Button, Row, Col } from 'hljd'
import MsgModal from '../MsgModal'

export default class extends Component {
  render() {
    return (
      <div style={{ fontSize: 16, padding: 40, color: '#333' }}>
        <img
          src="http://qnm.hunliji.com/o_1bk3fnk51su85a81lj41o5b17f87.jpg"
          style={{ height: 160, width: 880 }}
        />
        <p style={{ padding: '36px 60px' }}>
          轻松聊是婚礼纪基于用户行为捕捉开发的一款商家营销工具，系统会捕捉到对商家/套餐/案例有意向的用户，自动展示商家预设的接客问候语（接客问候也会展示在私信记录中），引导用户主动向商家发起私信。
        </p>
        <Row gutter={60}>
          <Col span={12} style={{ textAlign: 'right' }}>
            <img src="http://qnm.hunliji.com/o_1bkqsn2ir1ucf1abg1r961fcrqui9.gif" />
            <p
              style={{
                width: 280,
                float: 'right',
                textAlign: 'left',
                margin: '10px 0',
                fontSize: 14
              }}
            >
              步骤一：当用户进入详情页，并持续浏览时，系统会唤起预设好的话术的问候气泡。
            </p>
          </Col>
          <Col span={12}>
            <img src="http://qnm.hunliji.com/o_1bkqsn2irjsbe59124kkq11grk8.gif" />
            <p style={{ width: 280, margin: '10px 0', fontSize: 14 }}>
              步骤二：用户点击问候气泡，直接跳转至私信界面，系统会把预设好的话术显示在聊天记录中。
            </p>
          </Col>
        </Row>
        <div
          style={{
            textAlign: 'center',
            paddingTop: 30,
            marginTop: 20,
            borderTop: '1px solid #e7e7e7'
          }}
        >
          <Button
            type="primary"
            style={{ width: 160, height: 40 }}
            onClick={this.props.store.countDown}
          >
            申请开通
          </Button>
          <p style={{ color: '#ff801a', fontSize: 14, marginTop: 10 }}>
            限时免费<span
              style={{ textDecoration: 'line-through', padding: '0 4px' }}
            >
              2999
            </span>元/年
          </p>
        </div>

        <MsgModal store={this.props.store} />
      </div>
    )
  }
}
